import script from "./WorkflowSettingsTags.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowSettingsTags.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowSettingsTags.vue?vue&type=style&index=0&id=17685680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17685680"]])

export default __exports__